<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord(params.data)"
		/>
		<feather-icon
			v-if="OptimizationGroupDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";

export default {
	name: "CellRendererActions",
	computed: {
		OptimizationGroupDeletePermission() {
			return this.$store.getters.checkPermission("OPTIMIZATION_GROUP_D");
		},
	},
	methods: {
		editRecord(data) {
			this.$store.commit("moduleOptimizationGroup/SET_OPTIMIZATION_GROUP_EDIT", data);
			this.$store.commit("moduleOptimizationGroup/SET_OPTIMIZATION_GROUP_SIDEBAR_ACTIVE", true);
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Group.DeleteGroup.Text1") +
					` "${this.params.data.name}"? ` +
					this.$t("Group.DeleteGroup.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleOptimizationGroup/deleteById", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Group.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("Group.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
	},
};
</script>
